<template>
<div class='vue-form'>

  <b-jumbotron :header='intro.title' :lead='intro.subtitle' header-level='5'>
    <hr />
    <p v-html="intro.desc" style="margin-bottom: 0;">
    </p>
  </b-jumbotron>

  <form ref='form' :action='results.action' method='post' @submit='onSubmit' name="vfm">
    <input type='hidden' name='post' :value='results.post' />
    <!-- <div class='email_field_group' v-for='email, index in results.emails'>
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_from_name"' :value='email.from_name' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_from"' :value='email.from' />
      <input v-if='(email.to === "self")' type='hidden' :name='"email_" + (index+1).toString()+ "_to"' :value='items.vfm_email.data'  />
      <input v-else type='hidden' :name='"email_" + (index+1).toString()+ "_to"' :value='email.to' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_subject"' :value='email.subject' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_body"' :value='email.body' />
    </div> -->

    <div class='email_field_group'>
      <input type='hidden' :name='"email_1_from_name"' :value='results.emails[0].from_name' />
      <input type='hidden' :name='"email_1_from"' :value='results.emails[0].from' />
      <input type='hidden' :name='"email_1_to"' :value='results.emails[0].to' />
      <input type='hidden' :name='"email_1_subject"' :value='results.emails[0].subject' />
      <input type='hidden' :name='"email_1_body"' :value='email_1_body' />
    </div>

    <div class='email_field_group'>
      <input type='hidden' :name='"email_2_from_name"' :value='results.emails[1].from_name' />
      <input type='hidden' :name='"email_2_from"' :value='results.emails[1].from' />
      <input type='hidden' :name='"email_2_to"' :value='items.vfm_email.data' />
      <input type='hidden' :name='"email_2_subject"' :value='results.emails[1].subject' />
      <input type='hidden' :name='"email_2_body"' :value='email_2_body' />
    </div>

    <div class='csv_field_group' v-for='csv, f_index in csvPath_a'>
      <input type='hidden' :name='"csv_"+(f_index+1).toString()+"_file"' :value='csv.path' />
      <!-- <input v-for='item, key, i_index in items' v-if='csv.omit.indexOf(key) === -1' :key='key' :name='csvEnum(item.name, f_index, i_index)' type='hidden' :value='item.name' /> -->
      <input v-for='item, key, i_index in items' :key='key' :name='csvEnum(item.name, f_index, i_index)' type='hidden' :value='getCSVValue(csv.omit, key)' />
      <input :name='stampEnum(f_index)' type='hidden' value='Stamp' />
    </div>

    <input type='hidden' name='Enroll' :value='results.enroll' />
    <input type='hidden' name='Stamp' :value='results.stamp' />
    <input type='hidden' name='confirm' :value='results.confirm' />
    <input type='hidden' name='confirm_template' :value='confirm_template'  />
    <div class='miners'>
      <label>hidden
        <input class='miners' name='miners' value='' />
      </label>
    </div>

    <!-- <b-modal v-model='meta.closed'></b-modal> -->

    <div class='vfm_item' v-for='item, key in items'>
      <div v-if="item.section_header">
        <h4>{{ item.section_header }}</h4>
      </div>
 
      <b-form-group v-if='((item.type === "radio") && (item.class === "indent25"))' v-show='item.show' :label-for='item.name' :description='item.help' style='padding-left: 25px'>

        <label>{{ item.label }}
        <b-form-radio-group stacked v-model='item.data' v-on:input='radioTrig(key, item.ctrl, item.data)' style='padding-left: 25px' :name='item.name' :options='item.init.options'></b-form-radio-group>

        <input hidden type='radio' :name='item.name' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}' />
        </label>

        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "radio"))' v-show='item.show' :label-for='item.name' :description='item.help'>
        
        <label>{{ item.label }}
        <b-form-radio-group stacked v-model='item.data' v-on:input='radioTrig(key, item.ctrl, item.data)' style='padding-left: 25px' :name='item.name' :options='item.init.options'></b-form-radio-group>

        <input hidden type='radio' :name='item.name' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}' />
        </label>

        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "select") && (item.class === "indent25"))' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help' style='padding-left: 25px'>
        <b-form-select v-model='item.data' style='padding-left: 25px' :name='item.name' :options='vfm_init(key)' v-validate='item.reqs' data-vv-validate-on='blur' :class='{"is-danger":errors.has(item.name)}'>
        </b-form-select>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "select"))' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-select v-model='item.data' :name='item.name' :options='vfm_init(key)' v-validate='item.reqs' data-vv-validate-on='blur' :class='{"is-danger":errors.has(item.name)}'>
        </b-form-select>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "checkbox"))' v-show='item.show' :label-for='item.name'>
        <b-form-checkbox v-model='item.data' :name='item.name' v-on:input='radioTrig(key,item.ctrl, item.data)' unchecked-value='' value='Yes' v-validate='item.reqs'> {{ item.label }}
        </b-form-checkbox>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>
			
			<b-form-group v-else-if='((item.type === "checkboxgroup"))' :label='item.label' :name='item.name' :id='item.name' :description='item.help' v-show='item.show' v-validate='item.reqs'>
        <b-form-checkbox-group stacked  v-model='item.data' :options='item.init.options' :name='item.name' :aria-describedby='item.label'>
        </b-form-checkbox-group>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='(item.type === "textarea")' v-show='item.show' :label-for='item.name' :description='item.help'>
        <label>{{ item.label }}
        <b-form-textarea v-model='item.data' :name='item.name' :placeholder='item.init.placeholder' :rows='5' :max-rows='10' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-textarea>
        <span v-if='item.reveal'>
          <b-btn variant='link' size='sm' v-show='(item.reveal && !items[item.reveal.target].show)' v-on:click='clickReveal(item)'>{{item.reveal.text}}</b-btn>
        </span>
        <span v-if='(item.hide && item.reveal)'>
          <b-btn variant='link' size='sm' v-show='(item.hide && !items[item.reveal.target].show)' v-on:click='clickHide(item)'>
            {{item.hide.text}}
          </b-btn>
        </span>
        <span v-if='(item.hide && typeof(item.reveal) === "undefined")'>
          <b-btn variant='link' size='sm' v-show='item.hide' v-on:click='clickHide(item)'>
             {{item.hide.text}}
           </b-btn>
        </span>
        </label>
        
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='(item.type === "link")' v-show='item.show' :description='item.help'>
        <span v-html='item.label'></span>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "text") && (item.class === "indent25"))' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help' style='padding-left: 25px'>
        <b-form-input v-model='item.data' style='padding-left: 25px' :name='item.name' :placeholder='item.init.placeholder' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'>
        </b-form-input>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-input :type='item.type' :name='item.name' :id='item.name' v-model='item.data' :placeholder='vfm_init(key)' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-input>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>
    </div>

    <b-alert show variant="warning" id="terms-gp" name="terms-gp" v-if='terms.show'>
       <h6 v-if="terms.title">{{terms.title}}</h6>
       <p class="help-text" v-if="terms.text">{{terms.text}}</p>
       <hr v-if="terms.text">
       <b-form-checkbox id="terms-cb" name="terms-cb" v-model="terms.data" value="accepted" unchecked-value="" v-validate.initial="'required'">{{terms.label}}</b-form-checkbox>
   </b-alert>
    <hr />
    <b-button :disabled='errors.any()' size='lg' type='submit' variant='dark'>Submit</b-button>
    <!-- <b-button :disabled='true' size='lg' type='submit' variant='dark'>Submit</b-button> -->
  </form>

  <div id="debug" class="debug" v-show="false">
    <h2>Debug</h2>
    <div>
      Errors = {{errors.any()}}<br /> {{errors.all()}}
    </div>
    <ul v-for='item in items'>
      <li>
        <div>{{item.name}}: <span class="data-debug">{{item.data}}</span></div>
        <div v-if='item.ctrl'>{{item.ctrl}}</div>
      </li>
    </ul>
    <div v-for='csv in csvPath_a'>
      {{csv.path}}
    </div>
    <div>
      {{ results.confirm }}
    </div>
  </div>

  <div id='confirm_template' v-show="false">
    <b-row>
      <b-col><p>Your Financial Aid Outside Assistance Form has been submitted. If you have any questions or changes, please contact {{ meta.poc_name }} at <a :href="'mailto:' + meta.poc_email1">{{ meta.poc_email1 }} </a>.</p></b-col>
    </b-row>
    <hr />
    <b-row><strong>Submission Details:</strong></b-row>
    <b-row v-for="item in items" :key="item.name">
      <b-col cols="4"><strong>{{ item.label }}</strong></b-col>
      <b-col cols="8">{{ item.data }}</b-col>
    </b-row>
  </div>

  <div id='email_template_1' v-show="false">
    <div style=''>
      <table border="0" style="border-collapse: collapse; font: Arial normal 10pt ;" cellpadding="3">
        <tr>
            <td colspan="4">
               <p>This is an automated message to let you know that you have a new submission of the <em>{{ meta.form_name }}</em> located at <a :href="'https://interact.sdsmt.edu/' + meta.root + '/' + meta.sub + '/'">https://interact.sdsmt.edu/{{meta.root}}/{{ meta.sub }}/</a>.</p>

                <p>The link to the submission results file for this form is <a :href="'https://sdmines.sdsmt.edu/upload/results/' +results.csv_files[0].path + results.csv_files[0].file">https://sdmines.sdsmt.edu/upload/results/{{ results.csv_files[0].path }}{{ results.csv_files[0].file }}</a>. Remember, this file may contain personally identifiable information from previous submissions, so please do not share this link.</p>

               <p>If you have any trouble accessing the data you've received from this submission, please contact <a href="mailto:vickie.bender@sdsmt.edu">ITS</a>.</p>
            </td>
        </tr>
      </table>
      <hr />
      <h4>Submission Information</h4>
      <hr />
      <table>
        <tr><td></td></tr>
          <tr v-for="item in items" :key="item.name">
            <td style="vertical-align:top"><b>{{ item.label }}</b></td>
            <td style="vertical-align:top">{{item.data}}</td>
          </tr>
        <tr><td></td></tr>
      </table>
    </div>
  </div>

  <div id='email_template_2' v-show="false">
    <div style=''>
      <table border="0" style="border-collapse: collapse; font: Arial normal 10pt ;" cellpadding="3">
        <tr>
            <td colspan="4">
              <p>Your Financial Aid Outside Assistance Form has been submitted. If you have any questions or changes, please contact {{ meta.poc_name }} at <a :href="'mailto:' + meta.poc_email1">{{ meta.poc_email1 }} </a>.</p>
            </td>
        </tr>
      </table>
      <hr />
      <h4>Submission Information</h4>
      <hr  />
      <table>
        <tr><td></td></tr>
          <tr v-for="item in items" :key="item.name">
            <td style="vertical-align:top"><b>{{ item.label }}</b></td>
            <td style="vertical-align:top">{{item.data}}</td>
          </tr>
        <tr><td></td></tr>
        <tr>
          <td colspan="4">
             <p><em>This is an automated response.</em></p>
          </td>
        </tr>
      </table>
    </div>
  </div>

</div>
</template>

<script>
import {
  meta,
  intro,
  results,
  path_hash,
  terms,
  items
} from 'vfm/form-specs'

var timestamp = require('time-stamp');

export default {
  name: 'VueForm',
  computed: {

    csvPath_a: function() {
      var a = [];
      for (var i = 0; i < this.results.csv_files.length; i++) {
        a[i] = {
          path: this.csvPath(i),
          omit: this.results.csv_files[i].omit
        };
      }
      return a;
    },

    vfm_combined_name: function() {
      var s = '';
      for (var i = 0; i < this.hiddens.email_from_name.length; i++) {
        if (i !== 0) {
          s += ' '
        }
        if (typeof this.items[this.hiddens.email_from_name[i]] !== 'undefined') {
          s += this.items[this.hiddens.email_from_name[i]];
        } else s += this.hiddens.email_from_name[i];
      }
      return s;
    },
  },

  data() {
    return {
      meta: meta,
      results: results,
      items: items,
      intro: intro,
      path_hash: path_hash,
      terms: terms,
      email_1_body: '',
      email_2_body: '',
      confirm_template: ''
    }
  },

  methods: {
    stampNow() {
      return timestamp('YYYY/MM/DD-HH:mm:ss')
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.email_1_body = document.getElementById('email_template_1').innerHTML;
      this.email_2_body = document.getElementById('email_template_2').innerHTML;
      this.confirm_template = document.getElementById('confirm_template').innerHTML;
      results.stamp = this.stampNow();
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.results.miners !== '') {
            results.action = 'https://interact.sdsmt.edu/not-authorized.asp';
          } else {
            // update
            results.action = 'https://sdmines.sdsmt.edu/cgi-bin/global/send_message_2.cgi';

          }
          this.$nextTick(() => {
            this.$refs.form.submit();
          });

        } else {
          alert('Oops. Please fill in the required fields.');
        }
      });
    },

    getCSVValue(omit, key) {
      if (omit.indexOf(key) === -1) {
        return items[key].name;
      } else return ' - ';
    },

    vfm_init(key) {
      var item = items[key];
      switch (item.type) {
        case 'select':
          if (item.data === '') {
            item.data = null;
          }
          var ph = (item.init.placeholder ? item.init.placeholder : 'Choose an option');
          var top = [{
            text: ph,
            value: null
          }];

          if (typeof item.ctrl !== 'undefined') {
            if (typeof item.ctrl.from !== 'undefined') {
              var key = items[item.ctrl.from];
              var opts = item.init.options[key.data];
              if (typeof opts !== 'undefined') {
                if (opts.indexOf(item.data) === -1) {
                  item.data = null;
                }
                var opts_oa = [];
                for (var i = 0; i < opts.length; i++) {
                  opts_oa[i] = {
                    text: opts[i],
                    value: opts[i]
                  }
                }
                return (top.concat(opts_oa));
              }

              top[0].text = item.ctrl.msg ? item.ctrl.msg : 'Options depend on another field...';
              return (top);
            }
          }
          return (top.concat(item.init.options));
        default:
          return (item.init.placeholder ? item.init.placeholder : ['Enter response here.']);
      }
    },

    csvEnum(name, f_index, i_index) {
      return 'csv_' + (f_index + 1).toString() + '_field_' + (i_index + 1).toString();
    },

    stampEnum(f_index) {
      var max = Object.keys(items).length;
      return 'csv_' + (f_index + 1).toString() + '_field_' + (max + 1).toString();
    },

    csvPath(f_index) {
      var s = '/upload/results/';
      var ref = this.results.csv_files[f_index].file;
      var path = s + this.results.csv_files[f_index].path;
      // if there's a field with the same name as ref, use its data to build the filename
      if (typeof this.items[ref] !== 'undefined') {
        var key = this.items[ref].data;
        if (key !== null && key !== '') {
          var code = this.path_hash[key];
          if (typeof code !== 'undefined') {
            return path + key + '-' + code + '.csv';
          } else console.log('Code not found for hashed value.');
        }
        return path + key + '.csv';
      }
      //else csv_filed[i].file is just a filename string
      return path + ref;
    },

    radioTrig(key, ctrl, data) {
      var r = '';
      if (typeof ctrl !== 'undefined') {
        for (var j = 0; j < ctrl.length; j++) {
          if (ctrl[j].opener === data) {
            for (var i = 0; i < ctrl[j].targets.length; i++) {
              this.items[ctrl[j].targets[i]].show = true;

              //if placeholder is optional
              if(this.items[ctrl[j].targets[i]].init.placeholder !== 'optional'){
                this.items[ctrl[j].targets[i]].reqs = 'required';
              }
            }
          } 
          else {
            for (var i = 0; i < ctrl[j].targets.length; i++) {
              this.items[ctrl[j].targets[i]].show = false;
              this.items[ctrl[j].targets[i]].data = '';
              this.items[ctrl[j].targets[i]].reqs = '';
            }
          }
        }
      }
    } // end radioTrig
  } // end methods
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h1,
h2 {
  font-weight: bold;
} */

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

div.is-danger {
  margin-top: .2rem;
  color: #B3A369;
  font-size: .8rem;
}

input.is-danger,
select.is-danger {
  border: solid #B3A369 1px;
}

.card-body p {
  font-size: .8rem;
  margin-bottom: 0;
}

.debug {
  font-size: .7em;
  max-width: 30%;
  height: 100%;
  overflow-y: scroll;
  position: fixed;
  border-right: solid 8px #B3A369;
  padding: 1em;
  right: 0;
  top: 0;
  background: rgba(7, 29, 73, 0.6);
  color: white;
  text-align: left;
  display: none;
}

.help-text {
  font-size: .8em;
  font-style: oblique;
  color: #666;
}

.data-debug {
  color: #999;
  font-style: oblique;
}

.jumbotron{
  /* background-color: #071d49;
  color: #fff;  */
  margin-bottom: 30px;
  font-size: .9rem;
  color: #071d49;
}

.miners {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/VueForm.vue